module.exports = __webpack_public_path__ + "c06c11b5b41d7c31cc83adc2ca14f8b6.svg";